import { useState } from "react";
import "react-quill/dist/quill.snow.css";
import { Navigate } from "react-router-dom";
import Editor from "../components/Editor";

export default function CreatePost() {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState();
  const [content, setContent] = useState("");
  const [redirect, setRedirect] = useState(false);
  async function createNewPost(ev) {
    // const data = new FormData();
    // data.set("title", title);
    // data.set("content", content);
    ev.preventDefault();
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/posts/createPost`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ title: title, content: content, image: image }),
      }
    );
    if (response.ok) {
      setRedirect(true);
    }
  }

  if (redirect) {
    return <Navigate to={"/"} />;
  }
  return (
    <form onSubmit={createNewPost}>
      <input
        type="title"
        placeholder={"Title"}
        value={title}
        onChange={(ev) => setTitle(ev.target.value)}
      />
      <input
        type="text"
        placeholder={"image URL"}
        value={image}
        onChange={(ev) => setImage(ev.target.value)}
      />
      <Editor value={content} onChange={setContent} />
      <button style={{ marginTop: "5px" }}>Create post</button>
    </form>
  );
}
